// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Canvas slide-over Scenario Catalog drawer: what is specific to this drawer.
 *
 * The panel itself is the shared
 * ../../packages/publishing/CatalogDrawerShell.module.css and the card is
 * ../../packages/publishing/PackageCard.module.css, as for the Model drawer;
 * header and search row are the shared packages/publishing components.
 */

/* The Model drawer's tier: like it, this drawer opens a details modal on top
   of itself, and the two are never open together. */
.ner_jOu1lYOO1saTTZ57 {
  --curio-drawer-z: var(--curio-z-dataset-drawer);
}

/* Browse all: the heading over one project's scenarios, its name and then
   how many it holds. Each group's card list ends in the shell's margin,
   which keeps the groups apart. */
.WNQQMH0L5KbaeJq3d23I {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 8px;
  font-size: var(--curio-font-size-sm);
  line-height: 1.3;
}

.UBoZ7uc7YQL174tTDJhs {
  min-width: 0;
  overflow-wrap: anywhere;
  font-weight: 700;
  color: var(--curio-text-primary);
}

.Lxct2Td8qX9c_UGzs3xN {
  font-weight: 600;
  color: var(--curio-text-secondary);
  white-space: nowrap;
}

/* The avatar square holds the project graph instead of a glyph. */
.w3NqXHL53LwIvIbtjn5s {
  overflow: hidden;
  background: var(--curio-card-bg);
}

.bPoxvSqxGdF5wqvyUEwc {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--curio-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* A link, not a button: it navigates to the project rather than acting on
   the scenario, so it takes neither the dark action fill nor the light
   destructive one (the same reasoning as the avatar's View details). */
.ECyp1dpcHr2bWMXftC2Y {
  border: 0;
  background: none;
  padding: 0;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--curio-text-primary);
  cursor: pointer;
  white-space: nowrap;
}

.ECyp1dpcHr2bWMXftC2Y:hover {
  text-decoration: underline;
}

/* In project: a scenario's buttons, a row under its card, in the catalogs'
   two treatments (PackageCard.module.css: the dark fill acts, the bordered
   light one takes away). Two classes deep, so the row's smaller box wins over
   the shared buttons' whatever order the stylesheets load in. */
.n98yymoYNhOW_WhimRKg {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.n98yymoYNhOW_WhimRKg > button,
.rhCsF39cnzdkIXw1wHHu > button {
  min-width: 0;
  height: 30px;
  padding: 0 10px;
  font-size: var(--curio-font-size-sm);
  white-space: nowrap;
}

/* On top of the In project tab: the commands that make scenarios of the
   canvas selection. */
.rhCsF39cnzdkIXw1wHHu {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.x_ImB2HNBaYVauYAVmA7 {
  margin-left: 8px;
  border: 0;
  background: none;
  padding: 0;
  font: inherit;
  font-weight: 600;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/scenarios/catalog/ScenarioCatalogDrawer.module.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;oDACoD;AACpD;EACE,+CAA+C;AACjD;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;uEAEuE;AACvE;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;gEAGgE;AAChE;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;sBACsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":["/*\n * Canvas slide-over Scenario Catalog drawer: what is specific to this drawer.\n *\n * The panel itself is the shared\n * ../../packages/publishing/CatalogDrawerShell.module.css and the card is\n * ../../packages/publishing/PackageCard.module.css, as for the Model drawer;\n * header and search row are the shared packages/publishing components.\n */\n\n/* The Model drawer's tier: like it, this drawer opens a details modal on top\n   of itself, and the two are never open together. */\n.overlayRoot {\n  --curio-drawer-z: var(--curio-z-dataset-drawer);\n}\n\n/* Browse all: the heading over one project's scenarios, its name and then\n   how many it holds. Each group's card list ends in the shell's margin,\n   which keeps the groups apart. */\n.groupHeading {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 0 0 8px;\n  font-size: var(--curio-font-size-sm);\n  line-height: 1.3;\n}\n\n.groupName {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-weight: 700;\n  color: var(--curio-text-primary);\n}\n\n.groupCount {\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n  white-space: nowrap;\n}\n\n/* The avatar square holds the project graph instead of a glyph. */\n.avatarThumb {\n  overflow: hidden;\n  background: var(--curio-card-bg);\n}\n\n.cardDescription {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--curio-text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* A link, not a button: it navigates to the project rather than acting on\n   the scenario, so it takes neither the dark action fill nor the light\n   destructive one (the same reasoning as the avatar's View details). */\n.openLink {\n  border: 0;\n  background: none;\n  padding: 0;\n  font-family: inherit;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--curio-text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.openLink:hover {\n  text-decoration: underline;\n}\n\n/* In project: a scenario's buttons, a row under its card, in the catalogs'\n   two treatments (PackageCard.module.css: the dark fill acts, the bordered\n   light one takes away). Two classes deep, so the row's smaller box wins over\n   the shared buttons' whatever order the stylesheets load in. */\n.cardControls {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cardControls > button,\n.inProjectActions > button {\n  min-width: 0;\n  height: 30px;\n  padding: 0 10px;\n  font-size: var(--curio-font-size-sm);\n  white-space: nowrap;\n}\n\n/* On top of the In project tab: the commands that make scenarios of the\n   canvas selection. */\n.inProjectActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.retry {\n  margin-left: 8px;\n  border: 0;\n  background: none;\n  padding: 0;\n  font: inherit;\n  font-weight: 600;\n  color: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayRoot": `ner_jOu1lYOO1saTTZ57`,
	"groupHeading": `WNQQMH0L5KbaeJq3d23I`,
	"groupName": `UBoZ7uc7YQL174tTDJhs`,
	"groupCount": `Lxct2Td8qX9c_UGzs3xN`,
	"avatarThumb": `w3NqXHL53LwIvIbtjn5s`,
	"cardDescription": `bPoxvSqxGdF5wqvyUEwc`,
	"openLink": `ECyp1dpcHr2bWMXftC2Y`,
	"cardControls": `n98yymoYNhOW_WhimRKg`,
	"inProjectActions": `rhCsF39cnzdkIXw1wHHu`,
	"retry": `x_ImB2HNBaYVauYAVmA7`
};
export default ___CSS_LOADER_EXPORT___;
